import React from "react";
import CancelButton from "@components/FlowActionButtons/CancelButton";
import { canUserCancel } from "./utils";

interface CancelMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    submittedByRole?: string | null;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}
const LANG_BASE = "vessel-call.movement-services";

const CancelMovement: React.FC<CancelMovementProps> = ({ movementFlowData, openDrawer }) => {
  if (!movementFlowData) {
    return null;
  }

  const isActionAvailable = canUserCancel(
    movementFlowData.task?.status || "",
    movementFlowData.task?.claimOwnerName || "",
    movementFlowData.status,
    movementFlowData.submittedByRole,
  );

  const handleCancelClick = () => {
    openDrawer("cancelDrawer");
  };

  return (
    <CancelButton
      langBase={LANG_BASE}
      permission="canCancelMovementService"
      isActionAvailable={isActionAvailable}
      onCancel={handleCancelClick}
    />
  );
};
export default CancelMovement;
